<template>

  <div>
    <div class="m-1">
      <b-row>
        <b-col cols="12" md="6" class="d-flex align-items-center justify-content-start mb-1 mb-md-0">
          <v-select
              v-model="perPage"
              class="per-page-selector d-inline-block mx-50"
              :options="perPageOptions"
              :clearable="false"/>
        </b-col>
        <b-col cols="12" md="6">
          <div class="d-flex align-items-center justify-content-end">
            <b-form-input v-model="searchQuery" class="d-inline-block mr-1" placeholder="Search..."/>
            <header-table :re-fetch-data="reFetchData"></header-table>
          </div>
        </b-col>
      </b-row>
    </div>

    <b-table
        ref="refListTable"
        primary-key="id"
        empty-text="No record found"
        :class="`position-relative table-sticky ${totalCount > 0 && totalCount < 5 ? 'dropdown-h150': ''}`"
        :items="fetchList"
        :fields="tableColumns"
        :sort-by.sync="sortBy"
        :sort-desc.sync="isSortDirDesc"
        responsive striped bordered hover show-empty>

      <template #cell(id)="data">
        <id-column-table :data="data.value"></id-column-table>
      </template>

      <template #cell(message)="data">
        <div class="text-nowrap">
          <feather-icon :id="`row-${data.item.id}-prev`" icon="EyeIcon" size="16" @click="previewModal(data.item)" class="mx-1"/>
        </div>
      </template>

      <template #cell(created_date)="data">
        <date-time-column-table :data="data.value"></date-time-column-table>
      </template>

      <template #cell(mail_type)="data">
        <div class="text-nowrap">
          <span v-if="data.value === 0">Contact</span>
          <span v-if="data.value === 1">University Department</span>
          <span v-if="data.value === 2">Partner Profile Approved</span>
          <span v-if="data.value === 3">Partner Register</span>
          <span v-if="data.value === 4">Student Profile Approved</span>
          <span v-if="data.value === 5">Student Register</span>
          <span v-if="data.value === 6">Partner Register Information</span>
          <span v-if="data.value === 7">Student Forgot Password</span>
          <span v-if="data.value === 8">University Department Forgot Password</span>
          <span v-if="data.value === 9">Partner Forgot Password</span>
          <span v-if="data.value === 10">Student Service Agreement</span>
          <span v-if="data.value === 11">Partner Service Agreement</span>
        </div>
      </template>

    </b-table>

    <div class="mx-2 mb-2">
      <b-row>
        <footer-table :data-meta="dataMeta"></footer-table>
        <b-col cols="12" sm="6" class="d-flex align-items-center justify-content-center justify-content-sm-end">
          <b-pagination
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
              v-model="currentPage"
              :total-rows="totalCount"
              :per-page="perPage"
              first-number last-number>

            <template #prev-text>
              <feather-icon icon="ChevronLeftIcon" size="18"/>
            </template>

            <template #next-text>
              <feather-icon icon="ChevronRightIcon" size="18"/>
            </template>

          </b-pagination>
        </b-col>
      </b-row>
    </div>

    <b-modal v-model="messageModalShow" ref="message-modal" title="Preview" cancel-title="Close" cancel-variant="outline-secondary" size="lg" centered no-close-on-backdrop ok-only>
      <div v-html="messageData"/>
    </b-modal>

    <Overlay :busy="busy"></Overlay>
  </div>

</template>

<script>
import {
  BCard, BRow, BCol, BFormInput, BButton, BTable, BMedia, BAvatar, BLink,
  BBadge, BDropdown, BDropdownItem, BPagination, BTooltip, BButtonToolbar, BButtonGroup, BOverlay, BTabs, BTab,
} from 'bootstrap-vue'
import {
  FooterTable, RemoveButtonTable, EditButtonTable, DateColumnTable,
  ActiveColumnTable, BooleanColumnTable, IdColumnTable, HeaderTable
} from '@/components/Table';

import vSelect from 'vue-select'
import {onUnmounted, ref} from '@vue/composition-api'
import store from "@/store";
import useList from './useList'
import Overlay from "@/components/Overlay.vue";
import {avatarText, getApiFile} from "@core/utils/filter";
import DateTimeColumnTable from "@/components/Table/DateTimeColumnTable.vue";

export default {
  components: {
    DateTimeColumnTable,
    BTab,
    BTabs,
    HeaderTable, FooterTable, RemoveButtonTable, EditButtonTable,
    DateColumnTable, ActiveColumnTable, BooleanColumnTable, IdColumnTable,

    BCard, BRow, BCol, BFormInput, BButton, BTable, BMedia, BAvatar, BLink, BBadge, BDropdown, BDropdownItem,
    BPagination, BTooltip, BButtonToolbar, BButtonGroup, BOverlay,

    vSelect,
    Overlay,
  },
  setup() {
    const STORE_MODULE_NAME = 'store'
    if (!store.hasModule(STORE_MODULE_NAME)) store.registerModule(STORE_MODULE_NAME, storeModule)
    onUnmounted(() => {
      if (store.hasModule(STORE_MODULE_NAME)) store.unregisterModule(STORE_MODULE_NAME)
    })

    const {
      tableColumns,
      perPage,
      currentPage,
      totalCount,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refListTable,
      busy,

      fetchList,
      reFetchData,
      resolveUserRoleVariant,
      resolveUserRoleIcon,
    } = useList()

    const messageData = ref('')
    const messageModalShow = ref(false)
    const previewModal = (dataItem) => {
      messageData.value = dataItem.message
      messageModalShow.value = true
    }

    return {
      tableColumns,
      perPage,
      currentPage,
      totalCount,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refListTable,
      busy,
      messageData,
      messageModalShow,


      fetchList,
      reFetchData,
      avatarText,
      getApiFile,
      previewModal,

      resolveUserRoleVariant,
      resolveUserRoleIcon,
    }
  }
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select';
</style>

